// ============================================================
// CENTRAL CONTENT FILE — replace all [PLACEHOLDER] values here
// without touching any layout or component code.
// ============================================================

const px = (id, w = 1200) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;
const us = (id, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const BUSINESS = {
  name: "Jeweller Kalika Prasad",
  tagline: "Where Tradition Meets Timeless Elegance",
  phones: [
    { display: "+91 33-79629081", href: "tel:+913379629081" },
    { display: "+91 91630 16486", href: "tel:+919163016486" },
  ],
  phoneDisplay: "+91 33-79629081",
  phoneHref: "tel:+913379629081",
  whatsappDisplay: "+91 85848 86600",
  whatsappHref: "https://wa.me/918584886600",
  email: "goldkalikaprasad@gmail.com",
  address: "214 G.T. Road, Shibpur Tram Depot, Howrah, West Bengal - 711102, India",
  hours: "Mon–Wed & Fri–Sun: 10:00 AM – 2:00 PM and 4:00 PM – 9:00 PM · Thursday: Closed",
  hoursLines: [
    "Monday – Wednesday: 10:00 AM – 2:00 PM & 4:00 PM – 9:00 PM",
    "Thursday: Closed",
    "Friday – Sunday: 10:00 AM – 2:00 PM & 4:00 PM – 9:00 PM",
  ],
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=214+G.T.+Road,+Shibpur+Tram+Depot,+Howrah,+West+Bengal+711102",
  mapsEmbed: "https://www.google.com/maps?q=214+G.T.+Road,+Shibpur+Tram+Depot,+Howrah,+West+Bengal+711102&output=embed",
  instagramUrl: "https://www.instagram.com/jewellerkalikaprasad", // confirm [INSTAGRAM URL]
  reviewsUrl: "https://g.page/r/Cdu44j4JL582EBM/review",
};

export const NAV_LINKS = [
  { label: "Home", id: "home" },
  { label: "About Us", id: "about" },
  { label: "Collections", id: "collections" },
  { label: "Our Directors", id: "directors" },
  { label: "Gallery", id: "gallery" },
  { label: "Instagram", id: "instagram" },
  { label: "Reviews", id: "reviews" },
  { label: "Contact", id: "contact" },
];

export const HERO = {
  image: "/brand/hero-model.webp",
  alt: "Bride in a red Banarasi saree wearing a full gold bridal set — choker, sitahar, earrings, bangles and rings — at Jeweller Kalika Prasad, Howrah",
  overline: "Jeweller Kalika Prasad · Howrah",
  lines: ["Where Tradition", "Meets Timeless", "Elegance"],
  subheading: "Purity You Trust. Designs You Love.",
  supporting:
    "Discover exquisite Gold, Diamond and Silver jewellery crafted for life's most precious moments.",
  highlights: [
    "BIS Hallmarked Gold",
    "Assured Purity",
    "Competitive Making Charges",
    "Attractive Gold Exchange Value",
  ],
};

export const TRUST_ITEMS = [
  "Assured Purity",
  "BIS Hallmarked Jewellery",
  "Transparent Pricing",
  "Competitive Making Charges",
  "Gold Exchange",
  "Trusted Service",
];

export const ABOUT = {
  image: "/showroom/showroom-lounge.webp",
  alt: "Inside the Jeweller Kalika Prasad showroom — crystal chandelier, glass counters and the founders' portraits on the heritage wall",
  title: "Jewellery That Carries a Legacy",
  paragraphs: [
    "At Jeweller Kalika Prasad, we believe jewellery is more than an ornament. It represents emotions, celebrations, relationships and memories that are cherished for generations.",
    "Our commitment is to offer beautiful jewellery with assured purity, thoughtful craftsmanship, transparent pricing and personalized service.",
    "From timeless traditional designs to contemporary creations, we bring together elegance, quality and value for every occasion.",
    "Our customers and their families remain at the heart of everything we do.",
  ],
};

export const WHY_US = [
  { icon: "BadgeCheck", title: "BIS Hallmarked Gold", text: "Quality and purity you can trust." },
  { icon: "ShieldCheck", title: "Assured Purity", text: "Every piece made with a commitment to quality." },
  { icon: "Coins", title: "Competitive Making Charges", text: "Beautiful jewellery at attractive making charges." },
  { icon: "Scale", title: "Transparent Pricing", text: "Clear and straightforward pricing." },
  { icon: "RefreshCcw", title: "Attractive Gold Exchange Value", text: "Fair and competitive value when you exchange your gold." },
  { icon: "Gem", title: "Exclusive Designs", text: "Traditional, contemporary and modern designs." },
  { icon: "Crown", title: "Bridal Jewellery Specialists", text: "Beautiful jewellery for your most memorable celebrations." },
  { icon: "PenTool", title: "Customized Jewellery", text: "Personalized designs created around your vision." },
  { icon: "HeartHandshake", title: "Premium Customer Service", text: "Personal attention from selection to after-sales service." },
  { icon: "Users", title: "Trusted by Generations", text: "Building relationships that go beyond a single purchase." },
];

export const COLLECTIONS = [
  { name: "Gold Jewellery", desc: "Timeless 22K craftsmanship for every occasion.", image: "/jewellery/gold-chains.jpg", alt: "22 carat gold chains with pendants from Jeweller Kalika Prasad", span: "md:col-span-7" },
  { name: "Diamond Jewellery", desc: "Brilliant cuts, set to perfection.", image: "/jewellery/diamond-rings.jpg", alt: "Diamond rings in Kalika Prasad signature boxes", span: "md:col-span-5" },
  { name: "Bridal Collection", desc: "Heirloom pieces for your most memorable day.", image: "/jewellery/bridal-display.jpg", alt: "Bridal gold choker, sitahar, bangles and earrings displayed at Jeweller Kalika Prasad showroom", span: "md:col-span-5" },
  { name: "Silver Jewellery", desc: "Everyday elegance in pure silver.", image: "/jewellery/silver-bracelets.jpg", alt: "Hallmark silver bracelets from Jeweller Kalika Prasad", span: "md:col-span-7" },
  { name: "Traditional Collection", desc: "Designs rooted in Bengali heritage.", image: "/jewellery/shakha-pola.jpg", alt: "Traditional Bengali shakha pola bangles with gold detailing from Jeweller Kalika Prasad", span: "md:col-span-4" },
  { name: "Antique Collection", desc: "Old-world charm, restored to glory.", image: "/jewellery/choker-set.jpg", alt: "Ornate antique-finish gold choker and earring set from Jeweller Kalika Prasad", span: "md:col-span-4" },
  { name: "Daily Wear", desc: "Light, graceful pieces for every day.", image: "/jewellery/gold-pendant.jpg", alt: "Gold mangalsutras with pendants from Jeweller Kalika Prasad", span: "md:col-span-4" },
];

export const CATEGORIES = [
  { name: "Rings", image: "/jewellery/umbrella-rings.jpg", alt: "Handcrafted gold rings from Jeweller Kalika Prasad" },
  { name: "Necklaces", image: "/jewellery/gold-pendant.jpg", alt: "Gold necklaces and mangalsutras from Jeweller Kalika Prasad" },
  { name: "Earrings", image: "/jewellery/chandelier-earrings.jpg", alt: "22 carat gold chandelier earrings from Jeweller Kalika Prasad" },
  { name: "Bangles", image: "/jewellery/shakha-pola.jpg", alt: "Traditional Bengali shakha pola bangles from Jeweller Kalika Prasad" },
  { name: "Bracelets", image: "/jewellery/gold-bracelet.jpg", alt: "22 carat BIS hallmarked gold bracelets from Jeweller Kalika Prasad" },
];

export const GALLERY = [
  { image: "/jewellery/bridal-display.jpg", label: "Bridal Collection", alt: "Bridal gold jewellery display at Jeweller Kalika Prasad showroom, Shibpur" },
  { image: "/jewellery/mangalsutra-stones.jpg", label: "Mangalsutras", alt: "Gold mangalsutras styled with white stones and petals" },
  { image: "/jewellery/diamond-rings.jpg", label: "Diamond Rings", alt: "Delicate diamond rings in Kalika Prasad signature boxes" },
  { image: "/jewellery/gold-chains.jpg", label: "Gold Chains", alt: "22 carat gold chains with crafted pendants" },
  { image: "/jewellery/stone-ring.jpg", label: "Statement Ring", alt: "22 carat gold bow ring adorned with radiant stones" },
  { image: "/jewellery/gold-bracelet.jpg", label: "Gold Bracelets", alt: "22 carat hallmarked gold bracelets with HUID code" },
  { image: "/jewellery/silver-watches.jpg", label: "Silver Watches", alt: "Hallmark silver watches from Jeweller Kalika Prasad" },
  { image: "/jewellery/umbrella-rings.jpg", label: "Gold Rings", alt: "Handcrafted gold rings from Jeweller Kalika Prasad" },
  { image: "/jewellery/silver-bracelets.jpg", label: "Silver Bracelets", alt: "Hallmark silver gents bracelets" },
  { image: "/jewellery/gold-pendant.jpg", label: "Gold Pendants", alt: "Gold mangalsutra pendants from Jeweller Kalika Prasad" },
  { image: "/jewellery/shakha-pola.jpg", label: "Shakha Pola", alt: "Traditional Bengali shakha pola bangles with gold work" },
  { image: "/jewellery/buckle-bracelet.jpg", label: "Designer Bracelet", alt: "22 carat gold buckle-design bracelet with stone detailing" },
  { image: "/jewellery/bracelet-stack.jpg", label: "Gold Bracelet Stack", alt: "Stacked gold bracelets with intricate bead work" },
  { image: "/jewellery/green-stone-bracelet.jpg", label: "Green Stone Bracelet", alt: "Gold bracelet with a striking green marquise stone" },
  { image: "/jewellery/floral-bracelet.jpg", label: "Floral Bracelet", alt: "Finely crafted floral gold bracelet with stone accents" },
  { image: "/jewellery/sitahar-set.jpg", label: "Sitahar Set", alt: "22 carat gold sitahar necklace with matching earrings from Jeweller Kalika Prasad" },
  { image: "/jewellery/choker-set.jpg", label: "Bridal Choker Set", alt: "Ornate gold choker with matching earrings, bridal collection" },
  { image: "/jewellery/chandelier-earrings.jpg", label: "Chandelier Earrings", alt: "22 carat gold floral chandelier earrings" },
  { image: "/jewellery/motif-earrings.jpg", label: "Motif Earrings", alt: "22 carat gold earrings with leaf and bird motif" },
  { image: "/jewellery/heart-earrings.jpg", label: "Chandbali Earrings", alt: "Heart-shaped gold chandbali earrings with detailed work" },
  { image: "/jewellery/maang-tika.jpg", label: "Maang Tikka", alt: "22 carat gold maang tikka collection from Jeweller Kalika Prasad" },
  { image: "/jewellery/tulip-chain.jpg", label: "Gold Chain", alt: "22 carat gold chain with fully detailed work" },
  { image: "/jewellery/jhumka-earrings.jpg", label: "Jhumka Earrings", alt: "Gold chandbali earrings with jhumka drops" },
  { image: "/jewellery/crescent-earrings.jpg", label: "Crescent Earrings", alt: "22 carat gold crescent chandbali earrings" },
  { image: "/jewellery/filigree-earrings.jpg", label: "Filigree Earrings", alt: "Gold filigree earrings with heart motif and crescent drops" },
];

export const DIRECTORS = [
  {
    name: "Ashok Gupta",
    designation: "Director",
    message: "Our journey is built on trust, quality, and a commitment to excellence.",
    photo: "/directors/ashok-gupta.webp",
    alt: "Ashok Gupta, Director of Jeweller Kalika Prasad, Howrah",
  },
  {
    name: "Shankar Gupta",
    designation: "Director",
    message: "We don't just create jewellery, we create memories that become a part of every family's story.",
    photo: "/directors/shankar-gupta.webp",
    alt: "Shankar Gupta, Director of Jeweller Kalika Prasad, Howrah",
  },
];

export const DIRECTORS_VISION =
  "Behind every piece of jewellery is a commitment to trust, quality and relationships. Our Directors continue to carry this vision forward with passion and dedication.";

// Placeholder tiles — swap `image` URLs with real Instagram posts/reels when connecting the feed.
export const INSTAGRAM = [
  { image: us("1630019852942-f89202989a59", 700), type: "photo", alt: "Instagram post of traditional gold jewellery" },
  { image: px("13784022", 700), type: "reel", alt: "Instagram reel of bridal jewellery" },
  { image: us("1601121141461-9d6647bca1ed", 700), type: "photo", alt: "Instagram post of gold necklace" },
  { image: px("33257668", 700), type: "photo", alt: "Instagram behind-the-scenes showroom moment" },
  { image: us("1611591437281-460bfbe1220a", 700), type: "reel", alt: "Instagram reel of gold rings" },
  { image: px("37485307", 700), type: "photo", alt: "Instagram post of gold bangles" },
];

export const SHOWROOM = {
  title: "Experience Jeweller Kalika Prasad",
  text: "Step into a world where timeless craftsmanship meets personalized service. Visit our showroom to explore our collections, discover new designs and experience jewellery shopping in a comfortable and welcoming environment.",
  images: [
    { image: "/showroom/showroom-interior.webp", label: "Our Showroom", alt: "Jeweller Kalika Prasad showroom — crystal chandelier over rows of glass display counters with royal green chairs" },
    { image: "/showroom/showroom-displays.webp", label: "Inside the Showroom", alt: "Wall display niches with gold necklaces and chains at Jeweller Kalika Prasad" },
  ],
  videoPlaceholder: true, // [SHOWROOM VIDEO] — replace with real video when available
};

export const VISION_BANNER = {
  image: "/brand/banner-showroom.webp",
  alt: "Inside the Jeweller Kalika Prasad showroom — gold jhoomar pendant, mangalsutra and diamond necklace on display in Shibpur, Howrah",
  title: "Building Trust, One Precious Moment at a Time",
  text: "Our vision is to make every jewellery-buying experience a relationship built on trust, transparency and excellence.",
};

export const FAQS = [
  { q: "Is your gold BIS hallmarked?", a: "Yes. Our gold jewellery is BIS hallmarked, so you can buy with complete confidence in its purity. Visit our showroom and our team will gladly show you the hallmarking details on any piece." },
  { q: "Do you offer gold exchange?", a: "Yes, we offer gold exchange at our showroom with a transparent evaluation process. Bring your old gold to our store and our team will assess it in front of you and explain the value clearly." },
  { q: "What are your making charges?", a: "Our making charges are competitive and depend on the design and type of jewellery you choose. Visit us or send an enquiry and we will share the details for the pieces you love." },
  { q: "Do you offer customized jewellery?", a: "Yes. We create personalized designs around your vision — from a sketch or an idea to a finished piece. Speak to our team at the showroom to begin your custom jewellery journey." },
  { q: "Do you have bridal jewellery?", a: "Yes, bridal jewellery is one of our specialties. From traditional sets to contemporary bridal designs, we help you find pieces worthy of your most memorable celebrations." },
  { q: "Do you have diamond jewellery?", a: "Yes, we carry a curated selection of diamond jewellery including rings, earrings, necklaces and more. Visit our showroom to explore the collection." },
  { q: "Do you have silver jewellery?", a: "Yes, we offer silver jewellery and articles. Visit the showroom to see the latest designs available." },
  { q: "Can I visit the showroom to see the collections?", a: "Absolutely — we would love to welcome you. Our full collections are best experienced in person, and our team will give you personal attention throughout your visit." },
  { q: "Where is Jeweller Kalika Prasad located?", a: `Our showroom is located at ${BUSINESS.address}. Use the Get Directions button on this page to navigate straight to us.` },
  { q: "What are your store timings?", a: `Our current opening hours are ${BUSINESS.hours}. Feel free to call or WhatsApp us before your visit and we will be ready to assist you.` },
];

export const ENQUIRY_TYPES = [
  "Gold Jewellery",
  "Diamond Jewellery",
  "Silver Jewellery",
  "Bridal Jewellery",
  "Gold Exchange",
  "Custom Jewellery",
  "General Enquiry",
];
